import { c as _c } from "react/compiler-runtime";
import { getHospitalTreatmentCaseListClient } from "../api/treatment-case.client";
import { useInfiniteQuery } from "@tanstack/react-query";
import { TREATMENT_CASE_SORT, TreatmentCaseListResponse, TreatmentCaseSort } from "@/shared/types/type/treatment";
import { ApiResponse } from "@/shared/types/interface/api";
export const useQueryHospitalTreatmentCaseList = (hospitalOriginId, t0, treatmentSubjectId) => {
  const $ = _c(4);
  const sort = t0 === undefined ? TREATMENT_CASE_SORT.CREATED_AT_DESC : t0;
  let t1;
  if ($[0] !== hospitalOriginId || $[1] !== sort || $[2] !== treatmentSubjectId) {
    t1 = {
      queryKey: ["hospitalTreatmentCaseList", hospitalOriginId, sort, treatmentSubjectId],
      queryFn: async t2 => {
        const {
          pageParam: t3
        } = t2;
        const pageParam = t3 === undefined ? 1 : t3;
        return await getHospitalTreatmentCaseListClient(hospitalOriginId, pageParam as number, sort, treatmentSubjectId);
      },
      initialPageParam: 1,
      getNextPageParam: _temp2
    };
    $[0] = hospitalOriginId;
    $[1] = sort;
    $[2] = treatmentSubjectId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return useInfiniteQuery(t1);
};
function _temp(count, page) {
  return count + page.result.contents.length;
}
function _temp2(lastPage, pages) {
  if (lastPage.status !== 200) {
    return;
  }
  const loadedCount = pages.reduce(_temp, 0);
  if (lastPage.result.contents.length === 0 || loadedCount >= lastPage.result.total) {
    return;
  }
  return pages.length + 1;
}